<template>
    <div class="wrapper-button">
        <div
            :key="idx"
            v-for="(el, idx) in buttons"
            class="rating-prizes_button"
            @click="action(el)">
            <InlineSvg
                :alt="el"
                class="rating-prizes_button__img"
                :src="image(el)">
            </InlineSvg>
            <p class="rating-prizes_button__text">
                {{ $t(`common.rating.banner.buttons.${ el }`) }}
            </p>
        </div>
    </div>
</template>

<script>
  import { UPDATE_OPTIONS } from "@core/store/action-constants";
  import { mapFields } from "@core/plugins/mapFields";
  import InlineSvg from "vue-inline-svg";
  import { encodeFilters } from "@core/filters";

  export default {
    components: { InlineSvg },
    computed: {
      buttons () {
        return ["omerta", "orders", this.hasDashboard && "hierarchy"].filter(Boolean);
      },

      ...mapFields("competition", {
        fields: ["isActive"],
        base: "options",
        action: UPDATE_OPTIONS
      }),

      hasDashboard () {
        return this.$route.name === "dashboard";
      }
    },

    methods: {
      image (key) {
        return require(`@/assets/Competition/Raffle/button/${ key }.svg`);
      },

      openModal () {
        this.isActive = true;
      },

      openOffers () {
        this.$router.push({
          name: "webmaster:offers",
          query: {
            backLink: this.$route.fullPath,
            filters: encodeFilters({ inCompetition: true })
          }
        });
      },

      openCompetitionRating () {
        this.$router.push({
          name: "webmaster:competitionRating",
          query: { backLink: this.$route.fullPath }
        });
      },

      action (key) {
        const data = { omerta: this.openModal, orders: this.openOffers, hierarchy: this.openCompetitionRating };
        data[key]();
      }
    }
  };
</script>

<style scoped lang="scss">
@import "~@/scss/competition-banner";


.wrapper-button {
  display: flex;
  gap: clamp(0.8125rem, -0.4614rem + 1.6345vw, 1.5rem); // 24px
}

.rating-prizes_button {
  position: relative;

  width: clamp(7.0625rem, 4.399rem + 3.4175vw, 8.5rem); // 136px
  height: clamp(2.5rem, 1.5736rem + 1.1887vw, 3rem); // 48px
  cursor: pointer;
  overflow: hidden;
  border-bottom-left-radius: 41px;

  @media screen and (max-width: 960px) {
    width: clamp(5.625rem, 4.7328rem + 3.9655vw, 7.0625rem);;
  }

  &:hover &__img {
    color: $main-color;
  }

  &__text {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);

    margin-left: clamp(2.8125rem, 1.0754rem + 2.2288vw, 3.75rem); // 60px

    font-family: "Rubik";
    font-weight: 500;
    font-size: clamp(0.75rem, 0.5184rem + 0.2972vw, 0.875rem); // 14px
    line-height: 129%;

    @media screen and (max-width: 960px) {
      margin-left: clamp(2.25rem, 1.9009rem + 1.5517vw, 2.8125rem);
      font-size: clamp(0.625rem, 0.4698rem + 0.6897vw, 0.875rem);
    }
  }

  &__img {
    width: 100%;
    height: 100%;

    color: $hover-red-color;
    transition: color 0.15s ease-in-out;
  }
}
</style>